<template>
    <div class="detail-header-container">
        <h4 class="page-title">{{title}}</h4>
        <div class="sidebar-group-btn" v-if="isShowBtn">
            <div class="round-btn" @click="refreshDetailPage()"><i class="fas fa-redo"></i></div>
            <div class="round-btn" @click="closeDetailPage()"><i class="fas fa-times"></i></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String
            },
            isShowBtn: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            refreshDetailPage() {
                this.$emit('refreshDetailPage')
            },
            closeDetailPage() {
                this.$emit('closeDetailPage')
            }
        },
    }
</script>

<style lang="css" scoped>
.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-title {
    color: var(--main-color-1);
    font-size: var(--detail-page-title);
}
.sidebar-group-btn{
    display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/DetailHeader.vue